<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="body-rw Chapter-rw" epub:type="bodymatter chapter" id="part001">
<h1 class="part-number"><a href="#/toc#toc-part001">Book I</a></h1>
<h1 class="part-title"><a href="#/toc#toc-part001">O Canada</a></h1>
<div class="epigraph">
<p class="noindent"><em>Some people call what we did “running away.” I call it “a strategic retreat before I started shooting motherfuckers in the head.” Isn’t that a nicer way to put things?</em></p>
<p class="attribution">—S<span class="small-caps">HAUN</span> M<span class="small-caps">ASON</span></p></div>
<div class="epigraph">
<p class="noindent"><em>No matter how far we get from the people who made me what I am today, I’m still not sleeping. So I guess they won after all. Bully for them.</em></p>
<p class="attribution">—G<span class="small-caps">EORGIA</span> M<span class="small-caps">ASON</span></p></div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part001.vue?4b347d53